import { get } from 'lodash-es';
import { useParams } from 'react-router';

import { PageLabel, PageLabelWrapper } from '@component/header/header.style';
import { useStoreSelector } from '@hook/store/store.hooks';

export const ConsumerName = () => {
  const { consumerId = '' } = useParams();
  const consumers = useStoreSelector((state) => state.consumers.data);

  return (
    <PageLabelWrapper>
      <PageLabel ml={0}>{get(consumers, [consumerId, 'name'])}</PageLabel>
    </PageLabelWrapper>
  );
};
